<!--
 * @Author: guoyu
 * @Date: 2020-05-09 14:15:31
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-04 17:45:51
 * @Description: 優惠券样式
 -->
 <template>
  <div
    class="coupons"
    :class="{
      'no-button-checked': checked && noUseButton,
      [backgroundType]: true,
      disabled,
      invalid,
      'no-use-button': noUseButton && !isPlayerCoupon
    }"
  >
    <div v-if="count > 1" class="coupon-count">{{$t('upgrade_page_views_order_components_coupons_bar_329', [ count ])}}</div>
    <div class="coupons-left flex-column-center">
      <template v-if="isPlayerCoupon">
        <div
          class="coupons-image"
          :style="{ backgroundImage: `url(${couponsInfo.imageUrl}?d=300x300)` }"
        />
      </template>
      <template v-else-if="couponsInfo.couponTemplate === 'FREE_ORDER'">
        <p class="coupons-amount free">{{$t('upgrade_page_views_order_components_coupons_bar_330')}}</p>
      </template>
      <template v-else-if="couponsInfo.couponTemplate === 'HALF_OFF'">
        <p class="coupons-amount">
          5
          <span class="amount-unit">{{$t('upgrade_page_views_order_components_coupons_bar_331')}}</span>
        </p>
      </template>
      <template
        v-else-if="couponOffTemplates.includes(couponsInfo.couponTemplate)"
      >
        <p class="coupons-amount">
          {{ couponsInfo.couponName.slice(0, 1) }}
          <span class="amount-unit">{{$t('upgrade_page_views_order_components_coupons_bar_331')}}</span>
        </p>
      </template>
      <template v-else>
        <p class="coupons-amount">
          {{ couponsInfo.couponAmount }}<span class="amount-unit">{{$t('upgrade_page_views_home_suggest_item_4')}}</span>
        </p>
        <p class="coupons-limit" v-if="couponsInfo.satisfyConditionDesc">
          {{ couponsInfo.satisfyConditionDesc }}
        </p>
      </template>
    </div>
    <div class="coupons-right">
      <div class="flex-column-center coupons-infos">
        <p class="coupons-name">{{ couponsInfo.couponName }}</p>
        <p class="coupons-time">{{ validityCalculationDesc }}</p>
        <p class="coupons-rule">{{ couponsInfo.useConditionDesc }}</p>
      </div>
      <template v-if="isPlayerCoupon">
        <div v-if="noUseButton" class="flex-column-center right-click">
          <span class="coupons-price">${{ couponsInfo.couponAmount }}</span>
          <span class="start-price">{{$t('upgrade_page_views_order_components_coupons_bar_332', [ couponsInfo.startAmount ])}}</span>
        </div>
        <div v-else class="flex-column-center right-click">
          <span class="coupons-info"
            >{{$t('upgrade_page_views_order_components_coupons_bar_333', [ couponsInfo.startAmount ,
              couponsInfo.couponAmount
            ])}}</span
          >
          <div
            class="use-button pointer"
            :class="{ checked }"
            @click="useCoupons"
          >
            {{ buttonText }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'

export default {
  name: 'CouponsBar',
  props: {
    couponsInfo: {
      type: Object,
      default: couponsInfoInit
    },
    disabled: {
      // 是否是禁用
      type: Boolean,
      default: false
    },
    checked: {
      // 是否是选中态
      type: Boolean,
      default: false
    },
    invalid: {
      // 是否失效
      type: Boolean,
      default: false
    },
    noUseButton: {
      // 属否有有触发按钮
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 1
    }
  },
  computed: {
    buttonText() {
      if (this.invalid) return i18n.t('upgrade_page_views_order_components_coupons_bar_334');
      if (this.checked) return i18n.t('upgrade_page_views_order_components_coupons_bar_335');
      return i18n.t('upgrade_page_views_order_components_coupons_bar_336');
    },
    isPlayerCoupon() {
      // 愚人节如花优化券, 仅供娱乐
      return (
        this.couponsInfo.couponTemplate.includes('EXCLUSIVE_COUPON') ||
        this.isRuhuaCoupon
      );
    },
    isRuhuaCoupon() {
      return this.couponsInfo.couponTemplate === 'LIKE_FLOWER';
    },
    backgroundType() {
      if (this.couponsInfo.couponTemplate === 'NEWCOMER_EXPERIENCE') {
        return 'coupons-40';
      } else if (this.isPlayerCoupon) {
        return 'coupons-player';
      }
      return 'coupons-0';
    },
    validityCalculationDesc() {
      return i18n.t('upgrade_page_views_order_components_coupons_bar_337') + this.couponsInfo.deadline.slice(0, 10);
    }
  },
  data() {
    return {
      couponOffTemplates: [
        // 折扣類型的優惠券
        'SIXTY_PERCENT_OFF', // 四折
        // 'HALF_OFF',
        'FORTY_PERCENT_OFF',
        'THIRTY_PERCENT_OFF',
        'TWENTY_PERCENT_OFF',
        'TEN_PERCENT_OFF'
      ]
    };
  },
  methods: {
    useCoupons() {
      if (this.isRuhuaCoupon) {
        this.$message.success(
          i18n.t('upgrade_page_views_order_components_coupons_bar_338')
        );
        return;
      }
      if (this.disabled || this.invalid) return;
      this.$emit('use', this.couponsInfo);
    }
  },
  created() {
    if (this.isRuhuaCoupon) {
      this.couponsInfo.imageUrl =
        'https://resource.3uplay.com/user-static/ruhua_03.png';
    }
  }
};
/**
 * @description: 優惠券展示字段
 */
function couponsInfoInit() {
  return {
    couponName: i18n.t('upgrade_page_views_order_components_coupons_bar_339'), // 優惠券名字
    validityCalculationDesc: '--', // 優惠券时间
    couponAmount: '0', // 優惠券金额
    satisfyConditionDesc: '0', // 满减描述
    useConditionDesc: i18n.t('upgrade_page_views_order_components_coupons_bar_340') // 使用规则
  };
}
</script>
<style lang="scss" scoped>
.flex-column-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.coupons {
  display: flex;
  justify-content: space-between;
  width: 369px;
  height: 98px;
  padding: 2px 5px 5px;
  margin-bottom: 5px;
  cursor: pointer;
  position: relative;
  color: #333333;
  .coupon-count {
    position: absolute;
    padding: 2px 8px;
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    color: $color-gray-1;
    border-radius: 0 6px;
    background: #ffccaf;
    top: 2px;
    right: 5px;
  }
}
.coupons-0,
.coupons-10 {
  background: url(~@/assets/image/background/coupons-10.png) no-repeat center;
  background-size: 379px 111px;
}
.coupons-40 {
  background: url(~@/assets/image/background/coupons-40.png) no-repeat center;
  background-size: 379px 111px;
}

.coupons-player {
  background: url('~@/assets/image/background/coupon-player.png') no-repeat
    center;
  background-size: 379px 111px;
  .coupons-info {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-price;
    margin-bottom: 2px;
  }
  .use-button {
    margin-right: 0;
  }
  .coupons-price {
    font-weight: 600;
    font-size: 36px;
    line-height: 50px;
    color: $color-price;
  }
  .start-price {
    font-size: 12px;
    line-height: 17px;
    color: $color-gray-2;
    margin-top: 4px;
  }
}
.coupons-left {
  width: 80px;
  margin-left: 10px;
  margin-right: 10px;
  .coupons-image {
    width: 66px;
    height: 66px;
    background: no-repeat center center / cover;
    border-radius: 2px;
  }
}
.coupons-limit {
  font-size: 12px;
  line-height: 17px;
  margin-top: 16px;
  color: $color-gray-2;
}
.coupons-amount {
  font-size: 36px;
  line-height: 1;
  font-weight: 600;
  text-align: center;
  color: $color-price;
  @include flex(center, flex-end);
  &.free {
    font-size: 30px;
  }
  .amount-unit {
    font-size: 14px;
    margin-bottom: 4px;
  }
}
.coupons-right {
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  margin-right: 16px;
}
.coupons-infos {
  padding-left: 10px;
  p {
    width: 100%;
    text-align: left;
  }
}
.coupons-name {
  max-width: 146px;
  font-size: 16px;
  font-weight: 500;
  color: $color-gray-1;
  @include ellipsis;
}
.coupons-time {
  margin: 10px 0;
}
.coupons-time,
.coupons-rule {
  font-size: 12px;
  color: $color-gray-2;
  margin-top: 6px;
}
.coupons-rule {
  color: #999999;
}
.use-button {
  height: 36px;
  min-width: 78px;
  padding: 0 11px;
  margin-right: 15px;
  line-height: 38px;
  text-align: center;
  white-space: nowrap;
  background: $color-yellow;
  border-radius: 18px;
  font-weight: 500;
  font-size: 14px;
  color: $color-gray-1;
}
.checked {
  border: 1px solid #fa006e;
  background: #ffffff;
  color: #fa006e;
}
.disabled {
  opacity: 0.5;
  .coupons-amount {
    color: rgba($color: $color-gray-1, $alpha: 0.3);
  }
  .coupons-limit {
    color: rgba($color: $color-gray-2, $alpha: 0.3);
  }
  .use-button {
    background: #cccccc;
  }
}
.invalid {
  opacity: 0.6;
  .coupons-amount {
    color: #999999;
    margin-bottom: 0;
  }
  .coupons-limit {
    display: none;
  }
  .use-button {
    background: #ffffff;
    border: 1px solid #999999;
    color: #aaaaaa;
  }
}
.no-use-button {
  .right-click {
    display: none;
  }
}
.no-button-checked {
  position: relative;
  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: 1px;
    right: 6px;
    background: url(~@/assets/image/background/coupon-icon-check.png) no-repeat
      center;
    background-size: 100% 100%;
  }
  &.coupons-0,
  &.coupons-10 {
    background: url(~@/assets/image/background/coupons-10-check.png) no-repeat
      center;
    background-size: 379px 111px;
  }
  &.coupons-40 {
    background: url(~@/assets/image/background/coupons-40-check.png) no-repeat
      center;
    background-size: 379px 111px;
  }
  &.coupons-player {
    background: url('~@/assets/image/background/coupon-player-check.png')
      no-repeat center;
    background-size: 379px 111px;
  }
}
</style>
